module.exports = __webpack_public_path__ + "img/logo-feature-gtzh.21716a1f.png";